<script setup lang="ts">
import { ref, onMounted, onUnmounted, nextTick } from "vue";
import { trans } from "laravel-vue-i18n";
import { MembershipData } from "@/ts/components/members";

interface Props {
    data: MembershipData;
}

const component = ref<HTMLDivElement>();
const props = defineProps<Props>();

const emit = defineEmits(["mounted"]);

onMounted(async () => {
    await nextTick();

    const updateHeight = () => {
        if (component.value) {
            const height = component.value.getBoundingClientRect().height;
            emit("mounted", height);
        }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
        updateHeight();
    });

    if (component.value) {
        resizeObserver.observe(component.value);
    }

    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);

    // Clean up
    onUnmounted(() => {
        if (component.value) {
            resizeObserver.unobserve(component.value);
        }
        window.removeEventListener("resize", updateHeight);
        window.removeEventListener("orientationchange", updateHeight);
    });

    // scroll to top
    window.scrollTo(0, 0);
});
</script>

<template>
    <div ref="component" class="flex w-full flex-col items-stretch px-4 pt-10 pb-4 md:p-10 lg:p-[3.75rem]">
        <h2 class="mb-6 text-center font-heading text-40 font-[690] uppercase [font-stretch:_190%] md:mb-4 lg:text-48">{{ trans("membership.success_title") }}</h2>
        <p class="mb-10 leading-normal">{{ trans("membership.success_message") }}</p>
        <a href="/kalender" class="btn btn-black">
            Bekijk onze kalender
            <svg-vue icon="arrow" class="ml-[.625rem] h-6 w-auto"></svg-vue>
        </a>
    </div>
</template>
